<template>
  <div class="complete-reset-card">
    <CheckCircleTwoTone
      :twoToneColor="['#ffffff', '#00946A']"
      class="success-icon"
    />
    <h2 class="success-title">新密碼完成</h2>
    <p class="success-subtitle">歡迎您加入 {{ SITE_NAME }}！</p>
    <p class="success-description">
      在這裡您可以按照自己的節奏，向智慧醫療的專家學習。
    </p>

    <a-button class="reset-complete-btn" @click="goToSignIn">
      進入 {{ SITE_NAME }}
    </a-button>
  </div>
</template>
<script setup>
import { CheckCircleTwoTone } from "@ant-design/icons-vue";
import { useRouter } from "vue-router";
import { SITE_NAME } from "../constants/site";

const router = useRouter();

function goToSignIn() {
  // 取得並記錄上一次訪問的路徑
  const lastVisitedPath = localStorage.getItem("lastVisitedPath");
  if (lastVisitedPath) {
    router.push(lastVisitedPath);
  } else {
    router.push("/sign-in");
  }
}
</script>
<style scoped>
.complete-reset-card {
  width: 100%;
  max-width: 550px;
  background-color: #ffffff;
  border-radius: 20px;
  padding: 42px 39px 0px 39px;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
}

.success-icon {
  font-size: 64px;
  margin-bottom: 16px;
}

.success-title {
  margin-top: 21px;
  font-weight: 700;
  font-size: 30px;
  color: #000000;
  margin: 0;
}

.success-subtitle {
  font-size: 18px;
  font-weight: 500;
  color: #797979;
  margin: 8px 0 0;
}

.success-description {
  font-size: 18px;
  font-weight: 500;
  color: #797979;
  text-align: center;
  margin: 0;
  padding: 0;
}

.reset-complete-btn {
  width: 100%;
  height: 64px;
  border-radius: 999px;
  background-color: #00946a;
  color: #ffffff;
  font-size: 18px;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 45px;
  margin-bottom: 33px;
  text-decoration: none;
}

/* ✅ RWD: 手機版調整 */
@media (max-width: 768px) {
  .complete-reset-card {
    padding: 32px 20px;
  }

  .success-icon {
    font-size: 52px;
    margin-bottom: 12px;
  }

  .success-title {
    font-size: 24px;
  }

  .success-subtitle,
  .success-description {
    font-size: 14px;
  }

  .reset-complete-btn {
    height: 48px;
    font-size: 16px;
    margin-top: 32px;
    margin-bottom: 24px;
  }
}
</style>
